<template>
  <div v-if="(!loaded)"><AppSpinner /></div>
  <div v-if="(loaded)">
    <div class="paddingPagListagens app-page-margin-withoutImage app-page-padding">
      <AppCitacao :titulo="item.titulo" :conteudo="item.subtitulo" class="mt-6" />
      <div class="flex flex-wrap mt-8 gap-4 dropdowns">
        <div class="filterBox flex flex-column gap-2">
          <div>
            <Dropdown @change="mt_loadData()" :options="tipos" v-model="filter.tipo" optionValue="id" optionLabel="descricao" showClear>
              <template #value="slotProps">
                <span v-if="(slotProps.value != null)" v-html="fc_getListOption(tipos, slotProps.value).descricao"></span>
                <span v-else v-html="fc_getText(null, 'filtro_tipo')"></span>
              </template>
              <template #option="slotProps">
                <div class="flex align-items-center gap-2">
                  <div v-html="slotProps.option.descricao"></div>
                </div>
              </template>
            </Dropdown>
            </div>
        </div>
        <div class="filterBox flex flex-column gap-2">
          <div>
            <Dropdown @change="mt_loadData()" :options="areas" v-model="filter.area" optionValue="id" optionLabel="nome" showClear>
              <template #value="slotProps">
                <span v-if="(slotProps.value != null)" v-html="fc_getListOption(areas, slotProps.value).descritivoMenu"></span>
                <span v-else v-html="fc_getText(null, 'filtro_area')"></span>
              </template>
              <template #option="slotProps">
                <div class="flex align-items-center gap-2">
                  <div v-html="slotProps.option.descritivoMenu"></div>
                </div>
              </template>
            </Dropdown>
          </div>
        </div>
      </div>
      <div v-if="(!list.loaded)"><AppSpinner /></div>
      <DataView v-if="(list.loaded)"
        ref="dv" dataKey="id" class="lista" :layout="list.layout"
        lazy :value="list.list" :rows="list.params.rows" :first="list.params.first" :totalRecords="list.totalRecords"
        :sortField="list.params.sortField" :sortOrder="list.params.sortOrder"
        :paginator="true" :alwaysShowPaginator="false" paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
        :currentPageReportTemplate="'{currentPage} / {totalPages}'"
        @page="mt_onPage($event)"
      >
        <!-- no records -->
        <template #empty>
          <div class="text-center mt-8" v-html="fc_getText(null, 'zeroPublicacoes', { first: true })"></div>
        </template>
        <!-- grid layout -->
        <template #grid="slotProps">
          <div class="flex flex-wrap w-full gap-3 mt-8">
            <ListItemPublicacao v-for="(forItem, forIndex) in slotProps.items" :key="forIndex" :item="forItem" />
          </div>
        </template>
      </DataView>
    </div>
  </div>
</template>

<script>
import DataView from 'primevue/dataview';
import ListItemPublicacao from '@/components/ListItemPublicacao.vue';
export default {
  components: {
    DataView,
    ListItemPublicacao,
  },
  data() {
    return {
      loaded: false,
      item: {},
      list: {
        loaded: false,
        layout: 'grid',
        filtersView: false,
        sort: 'dataPublicacao',
        totalRecords: 0,
        list: [],
        params: {
          first: 0,
          rows: 12,
          sortField: 'dataPublicacao',
          sortOrder: -1,
          filters: {},
        },
        filters: {},
      },
      areas: [],
      tipos: [],
      filter: { area: null, tipo: null }
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.loaded = true;
      this.mt_queryGet();
      this.mt_loadData();
    },
    mt_loadData() {
      this.list.loaded = false;
      this.mt_querySet();

      let query = '?tableParams=' + encodeURIComponent(JSON.stringify(this.list.params));
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key] != null) {
          query += (query.length == 0 ? '?' : '&') + (key + '=' + this.filter[key]);
        }
      });
      this.fc_fetch({ endpoint: 'Publicacoes/' + query, method: 'GET', success: this.mt_loadData_success, error: () => { this.fc_goRoute('home'); } });
    },
    mt_loadData_success(response) {
      if (response != null && response.list != null) {
        this.list.list = response.list;
        this.list.totalRecords = response.pagination.total;
      }
      this.list.loaded = true;
    },
    mt_onPage(data) {
      this.list.params.first = data.first;
      this.mt_querySet();
      this.mt_loadData();
    },
    mt_queryGet() {
      let first = this.fc_getUrlParam('first');
      if (first != null && !isNaN(first) && (Number(first) % this.list.params.rows) == 0) {
        this.list.params.first = Number(first);
      }

      let tipo = this.fc_getUrlParam('tipo');
      if (tipo != null && !isNaN(tipo) && this.tipos.filter(x => x.id == tipo)) {
        this.filter.tipo = Number(tipo);
      }

      let area = this.fc_getUrlParam('area');
      if (area != null && !isNaN(area) && this.areas.filter(x => x.id == area)) {
        this.filter.area = Number(area);
      }
    },
    mt_querySet() {
      let query = {
        first: this.list.params.first
      };

      Object.keys(this.filter).forEach(key => {
        if (this.filter[key] != null) {
          query[key] = this.filter[key];
        }
      });

      this.$router.replace({ name: this.$route.name, query: query });
    },
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'PublicacoesPagina/', method: 'GET', success: (response) => { this.item = response.item; resolve(); }, error: reject }); }));
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'EquipaAreas/', method: 'GET', success: (response) => { this.fc_responseList(response, this.areas); resolve(); }, error: reject }); }));
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'PublicacoesTipos/', method: 'GET', success: (response) => { this.fc_responseList(response, this.tipos); resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dropdowns .p-dropdown {
  border-radius: 0px !important;
  border-width: 0px 0px 1px 0px !important;
  border-color:#ced4da !important;
}
.dropdowns .p-dropdown:not(.p-disabled).p-focus {
  border-width: 0px 0px 1px 0px !important;
  border-color: #ced4da !important;
  box-shadow: none !important;
}
.dropdowns .p-dropdown.p-inputwrapper-filled {
  border-radius: 0px !important;
  border-width: 0px 0px 1px 0px !important;
  border-color:#000 !important;
}
.dropdowns .p-dropdown.p-inputwrapper-filled:not(.p-disabled).p-focus {
  border-width: 0px 0px 1px 0px !important;
  border-color: #000 !important;
  box-shadow: none !important;
}
.dropdowns .p-dropdown.p-inputwrapper-filled span {
  color: #000 !important;
  font-weight: 600;
}

.lista:deep(.p-paginator-current) {
  font-size: 1.5rem;
  color: #000;
  border: none;
  background: none;
  cursor: default;
}
.lista:deep(.p-paginator) {
  margin-top: 20px;
}
.lista:deep(.p-paginator .p-paginator-prev) {
  font-size: 1.5rem;
  border: none;
  background: none;
  color: var(--rsa-color);
}
.lista:deep(.p-paginator .p-paginator-prev:hover) {
  color: var(--rsa-gray-04);
}
.lista:deep(.p-paginator .p-paginator-next) {
  font-size: 1.5rem;
  border: none;
  background: none;
  color: var(--rsa-color);
}
.lista:deep(.p-paginator .p-paginator-next:hover) {
  color: var(--rsa-gray-04);
}
.lista:deep(.p-paginator .p-icon) {
  width: 2rem;
  height: 2rem;
}
.lista:deep(.p-paginator .p-disabled) {
  color: var(--rsa-gray-02);
}
</style>
